import ScreenLayoutViewController from './ScreenLayoutViewController';

export default ScreenLayoutViewController;
